import { render, staticRenderFns } from "./TrustAccount.vue?vue&type=template&id=906435bc&scoped=true"
import script from "./TrustAccount.vue?vue&type=script&lang=js"
export * from "./TrustAccount.vue?vue&type=script&lang=js"
import style0 from "./TrustAccount.vue?vue&type=style&index=0&id=906435bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906435bc",
  null
  
)

export default component.exports